import { SxProps } from '@mui/material';

export const tycLinkStylesSx: SxProps = {
	color: 'rgb(62,118,151)',
	textDecoration: 'none',
};
